import { render } from "./DobFields.vue?vue&type=template&id=1dfa41c9"
import script from "./DobFields.vue?vue&type=script&lang=js"
export * from "./DobFields.vue?vue&type=script&lang=js"
script.render = render

export default script